import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import PropTypes from 'prop-types';

import { getThemes } from '../../../reducers/portalConfig';
import { xssSanitize } from "../../../utils";

import { getThemeDetails } from "../utils";
import { useGlobalVariable } from "../hooks";

import OktaSignInWidget from './OktaSignInWidget';

const OktaAuthScheme = ({ scheme: oktaAuthScheme }) => {
  const { search } = useLocation();
  const urlSearchParams = new URLSearchParams(search);

  const themeData = useSelector(getThemes);
  const { logo } = getThemeDetails(themeData);

  const [showOnlyOktaParam] = useGlobalVariable('fromApiHub', 'fromApiHub', false);
  const [referrer] = useGlobalVariable('referrer', 'referrer', false, true);

  const acsUrl = new URL(oktaAuthScheme.oktaAcsUrl);
  const baseUrlString = acsUrl.protocol + '//' + acsUrl.host;

  let referrerURL;
  if (showOnlyOktaParam) {
    referrerURL = urlSearchParams.get('fromUrl');
  } else {
    const redirectPath = referrer ? xssSanitize(referrer) : '';
    referrerURL = redirectPath ? (window.location.origin + redirectPath) : '';
  }
  const relayState = {
    "tenantId": oktaAuthScheme.tenantId,
    "tenantDomainName": window.location.host,
  };
  if (referrerURL) {
    relayState.fromUrl = referrerURL;
  }
  const requestCtx = acsUrl.pathname+'?RelayState=' + JSON.stringify(relayState);
  const dest = baseUrlString + requestCtx;
  const config = {
    useClassicEngine: true,
    logo,
    baseUrl: baseUrlString,
    features: {
      idpDiscovery: true,
      rememberMe: false,
    },
    idpDiscovery: {
      requestContext: requestCtx,
    },
    i18n: {
      en: {
        'primaryauth.title': 'Sign in using Email',
        'primaryauth.username.placeholder': 'Email',
        'oform.errorbanner.title' : '',
      },
    },
    helpLinks: {},
  };

  return (
    <OktaSignInWidget
      config={config}
      onSuccess={(res) => {
        if (res.status === 'IDP_DISCOVERY') {
          res.idpDiscovery.redirectToIdp(dest);
        } else if (res.status === 'SUCCESS') {
          res.session.setCookieAndRedirect(dest);
        } else {
          // The user can be in another authentication state that requires further action.
          // For more information about these states, see:
          // https://github.com/okta/okta-signin-widget#rendereloptions-success-error
          // eslint-disable-next-line no-console
          console.log(res);
        }
      }}
      onError={error => {
        // This function is invoked with errors the widget cannot recover from:
        // Known errors: CONFIG_ERROR, UNSUPPORTED_BROWSER_ERROR
        // eslint-disable-next-line no-console
        console.log(error);
      }}
    />
  );
};

OktaAuthScheme.propTypes= {
  scheme: PropTypes.shape(),
}

export default OktaAuthScheme;
